export const VERSION = '1.0.0';

export const server = legacy => {
  if (window.location.hostname === 'localhost' || !window.location.hostname) {
    if (legacy) return 'http://reports.cci';
    return 'http://localhost:3000';
  }

  if (legacy) return 'https://reports.ccihub.com';
  return 'https://api.ccihub.com';
}

export const scpClient = () => {
  if (window.location.hostname === 'localhost' || !window.location.hostname) {
    return 'http://localhost:8080';
  }
  return 'https://scp.ccihub.com';
}



// WEBPACK FOOTER //
// ./src/constants/SiteVariables.js